
import React from 'react';
import { ModernLoadingScreen } from './loading/ModernLoadingScreen';

const LoadingFallback: React.FC = () => (
  <ModernLoadingScreen />
);

export default LoadingFallback;
